import React from 'react';
import {
	capitalize,
	formatHyphens,
	useIsMobile,
	useMatchMedia,
} from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { Tags } from 'src/components/ProgramDetails/SnapshotHeader/Tags';
import { ProgramHighlightsPanel } from '../ProgramHighlightsPanel';
import styles from './SnapshotHeader.module.scss';

export interface SnapshotHeaderProps {
	inView?: boolean;
	loading: boolean;
	program: GetMemberProgramQuery['memberProgram'];
}

export const SnapshotHeader: React.FC<SnapshotHeaderProps> = ({ inView, loading, program }) => {
	const { logos } = program?.studentFacingAcademicPartner || {};
	const isMobile = useIsMobile();
	const isDesktop = useMatchMedia('(min-width: 1052px)');

	const formatProgramType = (type: string) => {
		if (type?.includes('CERTIFICATE')) {
			return `${capitalize(type)} or Bootcamp`;
		} else {
			return capitalize(type);
		}
	};

	return (
		<section className={styles.headerContainer} data-testid='program-details-banner'>
			<Skeleton dataLoading={loading} height={isMobile ? 276 : 252} width={!isMobile && '50%'}>
				<div className={styles.contentLeft}>
					<img
						alt={
							program?.studentFacingAcademicPartner.logoAltText ||
							`${program?.studentFacingAcademicPartner.name} logo`
						}
						className={styles.snapshotLogo}
						src={logos?.color}
					/>
					<Typography Component='h1' variant='h2'>
						{formatHyphens(program?.name)}
					</Typography>
					<Typography className={isMobile && 'margin--top_4'} variant='body1' weight='bold'>
						{formatProgramType(program?.programKind)}
					</Typography>
					<Typography variant='body1'>{program?.studentFacingAcademicPartner.name}</Typography>
					<Tags loading={loading} program={program} />
				</div>
			</Skeleton>

			{inView && isDesktop && (
				<div className={styles.panelContainer}>
					<ProgramHighlightsPanel loading={loading} program={program} />
				</div>
			)}
		</section>
	);
};
